/* Hall of Heroes — Extras
 *
 * Two small features that don't need their own asset family:
 *   1) "Make a suggestion" lightbox under the DM's Satchel block.
 *      Submits via a mailto: link to the site owner so we don't have
 *      to stand up a server endpoint or handle storage. Opens the
 *      user's mail client with subject + greeting pre-filled.
 *   2) Footer credit at the very bottom of the page: "Made with [3
 *      hearts] by Jan" + Return to FramedFantasy link. Clicking the
 *      hearts grants +3 hearts (separate localStorage key from the
 *      triple-tap easter egg so users can claim both per day).
 *
 * Both pieces live here because each is small and they share no
 * logic with bigger modules. Loaded as a normal asset (defer).
 */
(function(){
  'use strict';

  /* ============================================================
     MAKE A SUGGESTION LIGHTBOX
     ============================================================ */
  var SUGGEST_ROOT = null;
  function ensureSuggestRoot(){
    if(SUGGEST_ROOT) return SUGGEST_ROOT;
    SUGGEST_ROOT = document.createElement('div');
    SUGGEST_ROOT.id = 'hoh-suggest-modal';
    SUGGEST_ROOT.className = 'hoh-suggest-modal';
    SUGGEST_ROOT.style.display = 'none';
    document.body.appendChild(SUGGEST_ROOT);
    SUGGEST_ROOT.addEventListener('click', function(e){
      if(e.target === SUGGEST_ROOT) window.hohCloseSuggest();
    });
    return SUGGEST_ROOT;
  }
  /* Touch device detection — mobile/tablet open the mail app via
     mailto:, desktop copies the address to the clipboard with a
     toast confirmation. Desktop mailto: behavior is unreliable
     (often opens an unconfigured Mail app or nothing at all), so
     a clipboard copy is the safer affordance there. */
  function hohSuggestIsTouch(){
    try { return window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches; }
    catch(_){ return false; }
  }
  var SUGGEST_EMAIL = 'Jan@framedfantasy.com';
  var SUGGEST_MAILTO = 'mailto:' + SUGGEST_EMAIL + '?subject=Hall%20of%20Heroes%20suggestion&body=Hey%20Jan%2C%0A%0AI%20had%20an%20idea%20for%20the%20Hall%3A%0A%0A';
  /* Desktop submit handler: copy email to clipboard and confirm. */
  window.hohSuggestCopyEmail = function(){
    try {
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(SUGGEST_EMAIL);
      } else {
        /* Legacy fallback for older browsers without async clipboard. */
        var ta = document.createElement('textarea');
        ta.value = SUGGEST_EMAIL;
        ta.style.position = 'fixed'; ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch(_){}
        document.body.removeChild(ta);
      }
    } catch(_){}
    /* Swap the button label briefly to confirm the copy. The user
       can paste into their mail client of choice without the modal
       trying to launch one for them. */
    var btn = document.querySelector('.hoh-suggest-submit');
    if(btn){
      var orig = btn.textContent;
      btn.textContent = 'Email copied';
      btn.classList.add('hoh-suggest-copied');
      setTimeout(function(){
        if(btn){ btn.textContent = orig; btn.classList.remove('hoh-suggest-copied'); }
      }, 1600);
    }
    setTimeout(hohCloseSuggest, 1700);
  };
  window.hohOpenSuggest = function(){
    var m = ensureSuggestRoot();
    var isTouch = hohSuggestIsTouch();
    /* Submit affordance differs by device:
         - Touch (phone/tablet): an <a href="mailto:..."> that opens
           the system mail app — that's the original flow that works
           well there.
         - Desktop: a <button> that copies Jan@framedfantasy.com to
           the clipboard and confirms. No mailto: invocation, so no
           half-broken Mail.app launch on machines without a
           configured client. */
    var submitBtn = isTouch
      ? '<a class="hoh-et-btn hoh-et-btn-primary hoh-suggest-submit" href="' + SUGGEST_MAILTO + '" onclick="setTimeout(hohCloseSuggest,400);">Submit</a>'
      : '<button type="button" class="hoh-et-btn hoh-et-btn-primary hoh-suggest-submit" onclick="hohSuggestCopyEmail()">Submit</button>';
    var leadSmall = isTouch
      ? 'Tap Submit and your mail app opens with my address ready. Write whatever you want.'
      : 'Tap Submit to copy my email — paste it into your mail app and write whatever you want.';
    /* R87: Hidden +3 heart claim — single clickable cluster of 3 small
       hearts in the brand palette (cyan / pink / green), same pattern
       as the footer credit. Once-per-day key. Tucked below the lead
       paragraph so it reads as a discovered bonus, not a CTA. */
    var suggestHeartsClaimed = (function(){
      try { return localStorage.getItem('hoh-suggest-hearts-' + new Date().toISOString().slice(0,10)) === '1'; }
      catch(_){ return false; }
    })();
    var suggestHeartsBlock = '<div class="hoh-suggest-hearts-row' + (suggestHeartsClaimed ? ' hoh-suggest-hearts-claimed' : '') + '">' +
      '<button type="button" class="hoh-suggest-hearts-claim" onclick="hohClaimSuggestHearts(this,event)" aria-label="Claim the hidden hearts">' +
        '<span class="hoh-suggest-heart hoh-suggest-heart-l" aria-hidden="true">&#9829;&#xFE0E;</span>' +
        '<span class="hoh-suggest-heart hoh-suggest-heart-c" aria-hidden="true">&#9829;&#xFE0E;</span>' +
        '<span class="hoh-suggest-heart hoh-suggest-heart-r" aria-hidden="true">&#9829;&#xFE0E;</span>' +
      '</button>' +
    '</div>';
    m.innerHTML =
      '<div class="hoh-suggest-backdrop"></div>' +
      '<div class="hoh-suggest-sheet" role="dialog" aria-label="Make a suggestion">' +
        '<button type="button" class="hoh-suggest-x" onclick="hohCloseSuggest()" aria-label="Close">&times;</button>' +
        '<div class="hoh-suggest-eyebrow">Make a Suggestion</div>' +
        '<h2 class="hoh-suggest-title">Got a fun idea?</h2>' +
        '<p class="hoh-suggest-lead">I am trying to make this place more useful. If you have a fun idea for what I can do with all these submitted characters, send it over. Mini-tools, themed events, sorting tricks, anything. The wilder the better.</p>' +
        suggestHeartsBlock +
        '<p class="hoh-suggest-lead-small">' + leadSmall + '</p>' +
        '<div class="hoh-suggest-cta-row">' +
          submitBtn +
          '<button type="button" class="hoh-suggest-cancel" onclick="hohCloseSuggest()">Maybe later</button>' +
        '</div>' +
      '</div>';
    m.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function(){ m.classList.add('hoh-suggest-open'); });
  };
  /* R87: Hidden +3 heart claim handler. Idempotent per day. Clicking
     the cluster grants +3 hearts to the bank, fires the heart-fly
     animation toward the header pill, and marks the daily key so
     repeat opens of this modal won't re-grant. */
  window.hohClaimSuggestHearts = function(btn, ev){
    if(ev){ try { ev.stopPropagation(); ev.preventDefault(); } catch(_){} }
    if(!btn) return;
    var key = 'hoh-suggest-hearts-' + new Date().toISOString().slice(0,10);
    var claimed = false;
    try { claimed = (localStorage.getItem(key) === '1'); } catch(_){}
    if(claimed){
      /* Quick wiggle + no grant — same UX as the footer claim. */
      try {
        btn.classList.remove('hoh-suggest-hearts-shake');
        void btn.offsetWidth;
        btn.classList.add('hoh-suggest-hearts-shake');
        setTimeout(function(){ btn.classList.remove('hoh-suggest-hearts-shake'); }, 450);
      } catch(_){}
      return;
    }
    try { localStorage.setItem(key, '1'); } catch(_){}
    if(typeof window.hohAddHeartsToBank === 'function'){
      try { window.hohAddHeartsToBank(3, 'earn_task'); } catch(_){}
    }
    if(typeof window.hohShowHeartToast === 'function'){
      try { window.hohShowHeartToast('A small thanks', 'For opening this.', true); } catch(_){}
    }
    /* Fly the hearts toward the header pill so the user sees them land. */
    if(typeof window.hohFlyHeartsToPill === 'function'){
      try { window.hohFlyHeartsToPill(btn, 3); } catch(_){}
    }
    /* Visually mark the cluster as claimed (greyed). Wrapper row gets
       the claimed class so the cluster fades; the button stays clickable
       (re-clicks just wiggle). */
    try {
      var row = btn.closest ? btn.closest('.hoh-suggest-hearts-row') : null;
      if(row) row.classList.add('hoh-suggest-hearts-claimed');
    } catch(_){}
  };
  window.hohCloseSuggest = function(){
    var m = document.getElementById('hoh-suggest-modal');
    if(!m) return;
    m.classList.remove('hoh-suggest-open');
    setTimeout(function(){
      m.style.display = 'none';
      if(!document.querySelector('.hoh-modal[style*="flex"], .hoh-et-modal.hoh-et-open')){
        document.body.style.overflow = '';
      }
    }, 200);
  };
  document.addEventListener('keydown', function(e){
    var m = document.getElementById('hoh-suggest-modal');
    if(m && m.style.display === 'flex' && e.key === 'Escape') window.hohCloseSuggest();
  });

  /* ============================================================
     FOOTER CREDIT + BONUS HEART BUNDLE
     ============================================================
     Appended to the bottom of .hoh-content so it appears after the
     entire main grid. Heart bundle uses the same 3-heart spotlight
     icon (rendered inline as 3 stacked SVG hearts). Click grants
     +3 hearts to the bank, gated by a daily localStorage key that
     is INDEPENDENT of the triple-tap banner key — claiming both is
     allowed by design (two distinct interaction surfaces).
  */
  function bonusKey(){ return 'hoh-footer-bonus-' + new Date().toISOString().slice(0,10); }
  function bonusClaimedToday(){ try { return localStorage.getItem(bonusKey()) === '1'; } catch(e){ return false; } }
  function setBonusClaimedToday(){ try { localStorage.setItem(bonusKey(), '1'); } catch(e){} }

  function buildFooterHtml(){
    return '<div class="hoh-page-footer">' +
      '<button type="button" class="hoh-page-footer-credit" id="hoh-page-footer-credit" aria-label="Made with love by Jan">' +
        '<span class="hoh-page-footer-text">Made with</span>' +
        /* Three stacked hearts in the brand palette (cyan / pink /
           green) — matches the rainbow tri-heart used in the rules
           "Click the hearts here for your first bonus" so the two
           controls share visual vocabulary. */
        '<span class="hoh-page-footer-hearts" aria-hidden="true">' +
          '<span class="hoh-page-footer-heart hoh-page-footer-heart-l">&#9829;&#xFE0E;</span>' +
          '<span class="hoh-page-footer-heart hoh-page-footer-heart-c">&#9829;&#xFE0E;</span>' +
          '<span class="hoh-page-footer-heart hoh-page-footer-heart-r">&#9829;&#xFE0E;</span>' +
        '</span>' +
        '<span class="hoh-page-footer-text">by Jan</span>' +
      '</button>' +
      /* The "Step Through The Portal" scroll-to-top affordance was
         removed by request — the made-with-love credit above is the
         only footer element. */
    '</div>';
  }

  /* Jan, 2026-09-27: the hearts pop where they were found (hohHeartBurst in
     hoh-wallet.js) instead of flying to the wallet pill, which the live Hall
     hides, so they used to land in the top-left corner. The name stays for
     its callers. */
  function flyHeartsToPill(originEl, n){
    if(!originEl || !n || typeof window.hohHeartBurst !== 'function') return;
    window.hohHeartBurst(originEl, { n: n });
  }
  /* Expose globally so hoh-your-hall.js (R43 stat click bonus) and any
     other module can reuse the heart pop without duplicating code. */
  try { window.hohFlyHeartsToPill = flyHeartsToPill; } catch(_){}

  function wireFooterCredit(){
    var btn = document.getElementById('hoh-page-footer-credit');
    if(!btn || btn.dataset.hohBound) return;
    btn.dataset.hohBound = '1';
    if(bonusClaimedToday()){
      btn.classList.add('hoh-page-footer-claimed');
    }
    btn.addEventListener('click', function(){
      if(bonusClaimedToday()){
        /* Already claimed — quick wiggle, no grant. */
        btn.classList.add('hoh-page-footer-claimed-shake');
        setTimeout(function(){ btn.classList.remove('hoh-page-footer-claimed-shake'); }, 450);
        return;
      }
      setBonusClaimedToday();
      btn.classList.add('hoh-page-footer-claimed');
      if(typeof window.hohAddHeartsToBank === 'function') window.hohAddHeartsToBank(3, 'earn_task');
      if(typeof window.hohUpdateHeartCounter === 'function') window.hohUpdateHeartCounter();
      if(typeof window.hohShowHeartToast === 'function') window.hohShowHeartToast('Thanks for scrolling', 'The Hall is built on people like you.', true);
      flyHeartsToPill(btn, 3);
    });
  }

  function ensureFooter(){
    if(document.getElementById('hoh-page-footer-credit')) return;
    var content = document.querySelector('.hoh-content');
    if(!content) return;
    var footer = document.createElement('div');
    footer.innerHTML = buildFooterHtml();
    content.appendChild(footer.firstChild);
    wireFooterCredit();
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(ensureFooter, 200); });
  } else {
    setTimeout(ensureFooter, 200);
  }
})();
